<template>
  <v-container
    v-if="show"
    id="user-profile"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-account-outline">
          <template v-slot:after-heading>
            <div class="title font-weight-light">
              <span class="body-1">Транзакция - </span>
              <v-spacer />
              <span class="body-2">{{ title }}</span>
            </div>
          </template>
          <base-material-tabs color="warning">
            <v-tab
              v-for="(tab, i) in tabs"
              :key="i"
            >
              {{ tab }}
            </v-tab>
            <v-tab-item>
              <v-form>
                <v-container class="py-0">
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-autocomplete
                        v-model="form.contract"
                        :filter="contract_filter"
                        :disabled="view"
                        :items="select.contract"
                        item-value="id"
                        label="Выберите договор"
                      >
                        <template v-slot:item="{item}">
                          {{ item.number }}/{{ item.date_number }} от {{ item.date_formatted }}<br>
                          {{item.owner.surname}}  {{item.owner.name}}  {{item.owner.patronymic}}
                        </template>

                        <template v-slot:selection="{item}">
                          {{ item.number }}/{{ item.date_number }} от {{ item.date_formatted }}
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <v-select
                        v-model="form.type"
                        :items="select.type"
                        label="Тип транзакции"
                        :disabled="view"
                        @change="type_change"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="form.direction"
                        :items="select.direction"
                        label="Направление"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.date.create"
                        label="Дата создания"
                        :disabled="view"
                        type="date"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.sum"
                        type="number"
                        label="Сумма"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.description"
                        label="Назначение"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="form.state"
                        label="Статус"
                        :disabled="view"
                        :items="select.state"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <v-row
                class="mx-auto"
                justify="space-around"
                style="max-width: 500px;"
              >
                <v-col cols="12">
                  <v-select
                    v-model="contragent.debet"
                    :items="select.contragents"
                    @change="contragent_debet_change"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.debet.name"
                    name="debet_name"
                    label="Плательщик"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.debet.inn"
                    name="debet_inn"
                    label="ИНН"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.debet.kpp"
                    label="КПП"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="form.debet.bank_name"
                    name="debet_bank_name"
                    color="secondary"
                    label="Банк"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.debet.bic"
                    name="debet_bank_bic"
                    color="secondary"
                    label="Бик"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.debet.ks"
                    color="secondary"
                    label="К/с"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.debet.rs"
                    :counter="20"
                    color="secondary"
                    label="Р/с"
                    :disabled="view"
                    :rules="[(v) => validateRs() || 'Неверно указан номер счета']"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row
                class="mx-auto"
                justify="space-around"
                style="max-width: 500px;"
              >
                <v-col cols="12">
                  <v-select
                    v-model="contragent.credit"
                    :items="select.contragents"
                    @change="contragent_credit_change"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.credit.name"
                    name="credit_name"
                    label="Получатель"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.credit.inn"
                    name="credit_inn"
                    label="ИНН"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.credit.kpp"
                    label="КПП"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="form.credit.bank_name"
                    name="credit_bank_name"
                    :disabled="view"
                    color="secondary"
                    label="Банк"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.credit.bic"
                    name="credit_bank_bic"
                    :disabled="view"
                    color="secondary"
                    label="Бик"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.credit.ks"
                    :disabled="view"
                    color="secondary"
                    label="К/с"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.credit.rs"
                    :counter="20"
                    :disabled="view"
                    color="secondary"
                    label="Р/с"
                    :rules="[(v) => validateRs(true) || 'Неверно указан номер счета']"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row
                class="mx-auto"
                justify="space-around"
              >
                <v-col cols="8">
                  <v-autocomplete
                    v-model="select.operation"
                    :filter="operation_filter"
                    :disabled="view"
                    :items="select.operations.filter(a=>!a.transaction)"
                    label="Выберите операцию"
                  >
                    <template v-slot:item="{item}">
                      <v-row>
                        <v-col cols="4">
                          <b>Даты</b>:<br>
                          Создание: {{ format(item.date.create) }}<br>
                          <span v-if="item.date.process">Исполнение: {{ format(item.date.process) }}<br></span>
                          Статус: {{ format(item.state_date) }}<br>
                          Сумма: {{ item.sum }}
                        </v-col>
                        <v-col cols="4">
                          <span v-if="item.debet">
                            <b>Плательщик</b>:<br>
                            {{ item.debet.name }}<br>
                            ИНН: {{ item.debet.inn }} КПП: {{ item.debet.kpp }}<br>
                            Банк: {{ item.debet.bank_name }} {{ item.debet.bic }}<br>
                            К/с: {{ item.debet.ks }}<br>
                            Р/с: {{ item.debet.rs }}
                          </span>
                        </v-col>
                        <v-col cols="4">
                          <span v-if="item.credit">
                            <b>Получатель</b>:<br>
                            {{ item.credit.name }}<br>
                            ИНН: {{ item.credit.inn }} КПП: {{ item.credit.kpp }}<br>
                            Банк: {{ item.credit.bank_name }} {{ item.credit.bic }}<br>
                            К/с: {{ item.credit.ks }}<br>
                            Р/с: {{ item.credit.rs }}
                          </span>
                        </v-col>
                        <v-col cols="12">
                          {{item.description}}
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:selection="{item}">
                      <v-row>
                        <v-col cols="3">
                          <b>Даты</b>:<br>
                          Создание: {{ format(item.date.create) }}
                        </v-col>
                        <v-col cols="3">
                          <span v-if="item.debet">
                            <b>Плательщик</b>:<br>
                            {{ item.debet.name }}
                          </span>
                        </v-col>
                        <v-col cols="3">
                          <span v-if="item.credit">
                            <b>Получатель</b>:<br>
                            {{ item.credit.name }}
                          </span>
                        </v-col>
                        <v-col cols="3">
                          Сумма: {{ item.sum }}
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    min-width="150"
                    color="primary"
                    :disabled="view"
                    @click="form.payments.push(select.operation), select.operation = null"
                  >
                    Добавить
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :items="form.payments"
                    :headers="table.payments"
                    :disabled="view"
                  >
                    <template v-slot:item.action="{item}">
                      <v-icon
                        :disabled="view"
                        @click="form.payments = form.payments.filter(a=>a!=item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
          </base-material-tabs>
          <v-row>
            <v-col
              cols="6"
            >
              <v-btn

                color="secondary"
                large
                min-width="100"
                @click="$emit('close')"
              >
                Назад
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="text-right"
            >
              <v-btn
                v-if="change"
                color="primary"
                large
                min-width="100"
                @click="save_transaction"
              >
                Сохранить
              </v-btn>
              <v-btn
                v-if="create"
                color="primary"
                large
                min-width="100"
                @click="create_transaction"
              >
                Создать
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    props: ['create', 'change', 'view', 'id', 'show'],
    data: () => ({
      contragent: {
        debet: {},
        credit: {},
      },
      loader: {
        show: false,
      },
      tabs: [
        'Основное',
        'Дебет',
        'Кредит',
        'Финансовые операции',
      ],
      table: {
        payments: [
          { text: 'Описание', value: 'description' },
          { text: 'Сумма', value: 'sum', width: 150 },
          { text: '', value: 'action' },
        ],
      },
      form: {
        contract: '',
        date: {
          create: '',
        },
        type: 0,
        direction: 1,
        description: '',
        debet: {
          bic: '',
          bank_name: '',
          ks: '',
          rs: '',
        },
        credit: {
          bic: '',
          bank_name: '',
          ks: '',
          rs: '',
        },
        sum: 0,
        state: 1,
      },
      select: {
        direction: [
          { value: 1, text: 'Приход' },
          { value: 2, text: 'Расход' },
        ],
        type: [],
        contract: [],
        contragents: [],
        state: [
          { value: 1, text: 'Новая' },
          { value: 2, text: 'Исполнена' },
          { value: 3, text: 'Удалена по расторжению договора' },
          { value: 8, text: 'Удалена' },
        ],
        operations: [],
        operation: {},
      },
      dict: {
        state: {
          1: 'Новая',
          2: 'Исполнена',
          3: 'Удалена по расторжению договора',
          8: 'Удалена',
        },
        direction: {
          1: 'Приход',
          2: 'Расход',
        },
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.id && (this.view || this.change)) {
            this.axios.post('/api/transaction/list', { id: this.id })
              .then(result => {
                if (!result.data.error) {
                  this.form = result.data.data[0]
                  this.form.payments = this.form.payments || []
                  this.form.credit = this.form.credit || {}
                  this.form.debet = this.form.debet || {}
                  this.form.date.create = moment(this.form.date.create).format('YYYY-MM-DD')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } if (this.create) {
            this.form = {
              contract: '',
              date: {
                create: '',
              },
              type: 0,
              direction: 1,
              description: '',
              debet: {
                bic: '',
                bank_name: '',
                ks: '',
                rs: '',
              },
              credit: {
                bic: '',
                bank_name: '',
                ks: '',
                rs: '',
              },
              sum: 0,
              state: 1,
            }
          }
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'create': function () {
        console.log('create')
      },
      'show': function () {
        if (this.show) {

        }
      },
    },
    watch: {

      'form.debet.bank_name': function () {
        if (!this.suggestion && $('[name=debet_bank_name]').length > 0) {
          this.suggestion = true
          $('[name=debet_bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.debet.bank_name = data.data.name.full || data.data.name.payment
              this.form.debet.bic = data.data.bic
              this.form.debet.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.debet.bic': function () {
        if (!this.suggestion2 && $('[name=debet_bank_bic]').length > 0) {
          this.suggestion2 = true
          $('[name=debet_bank_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.debet.bank_name = data.data.name.full || data.data.name.payment
              this.form.debet.bic = data.data.bic
              this.form.debet.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.credit.bank_name': function () {
        if (!this.suggestion3 && $('[name=credit_bank_name]').length > 0) {
          this.suggestion3 = true
          $('[name=credit_bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.credit.bank_name = data.data.name.full || data.data.name.payment
              this.form.credit.bic = data.data.bic
              this.form.credit.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.credit.bic': function () {
        if (!this.suggestion4 && $('[name=credit_bank_bic]').length > 0) {
          this.suggestion4 = true
          $('[name=credit_bank_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.credit.bank_name = data.data.name.full || data.data.name.payment
              this.form.credit.bic = data.data.bic
              this.form.credit.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.debet.inn': function () {
        if (!this.suggestion5 && $('[name=debet_inn]').length > 0) {
          this.suggestion5 = true
          $('[name=debet_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.debet.name = data.data.name.full
              this.form.debet.inn = data.data.inn
              this.form.debet.kpp = data.data.kpp
            },
          })
        }
      },
      'form.credit.inn': function () {
        if (!this.suggestion6 && $('[name=credit_inn]').length > 0) {
          this.suggestion6 = true
          $('[name=credit_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.credit.name = data.data.name.full
              this.form.credit.inn = data.data.inn
              this.form.credit.kpp = data.data.kpp
            },
          })
        }
      },
      'form.debet.name': function () {
        if (!this.suggestion7 && $('[name=debet_name]').length > 0) {
          this.suggestion7 = true
          $('[name=debet_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.debet.name = data.data.name.full
              this.form.debet.inn = data.data.inn
              this.form.debet.kpp = data.data.kpp
            },
          })
        }
      },
      'form.credit.name': function () {
        if (!this.suggestion8 && $('[name=credit_name]').length > 0) {
          this.suggestion8 = true
          $('[name=credit_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.credit.name = data.data.name.full
              this.form.credit.inn = data.data.inn
              this.form.credit.kpp = data.data.kpp
            },
          })
        }
      },
    },
    mounted: function () {
      console.log(this.change)
      this.form.date.create = moment().format('YYYY-MM-DD')
      for (let x in this.$store.state.dict.transaction_type) {
        this.select.type.push({ value: Number(x), text: this.$store.state.dict.transaction_type[x].name, direction: Number(this.$store.state.dict.transaction_type[x].direction) })
      }
      for (let x in this.$store.state.dict.contragents) {
        this.select.contragents.push({ text: this.$store.state.dict.contragents[x].name, value: this.$store.state.dict.contragents[x] })
      }
      this.axios.post('/api/contract/get', { nofill: true })
        .then(result => {
          if (!result.data.error) {
            this.select.contract = result.data.data
            for (let x in this.select.contract) {
              this.select.contract[x].date_formatted = moment(this.select.contract[x].date).format('DD.MM.YYYY')
              this.select.contract[x].owner.birthday = moment(this.select.contract[x].owner.birthday).format('DD.MM.YYYY')
              this.select.contract[x].date_number = moment(this.select.contract[x].date).format('DDMM')
              this.select.contract[x].kind_string = this.dict.kind[this.select.contract[x].kind]
            }
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.axios.post('/api/transaction/operations/list', { })
        .then(result => {
          if (!result.data.error) {
            this.select.operations = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
    },
    methods: {
      format: function (date, short) {
        if (short) return moment(date).format('DD.MM.YYYY')
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      validateRs: function (credit) {
        let error = {}
        let rs = this.form.debet.rs
        let bik = this.form.debet.bic
        if (credit) {
          rs = this.form.credit.rs
          bik = this.form.credit.bic
        }

        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      contragent_debet_change: function () {
        let data = this.contragent.debet
        console.log(data)
        this.form.debet.name = data.name
        this.form.debet.inn = data.inn
        this.form.debet.kpp = data.kpp
        this.form.debet.bank_name = data.bank
        this.form.debet.ks = data.ks
        this.form.debet.rs = data.rs
      },
      contragent_credit_change: function () {
        let data = this.contragent.credit
        console.log(data)
        this.form.credit.name = data.name
        this.form.credit.inn = data.inn
        this.form.credit.kpp = data.kpp
        this.form.credit.bank_name = data.bank
        this.form.credit.ks = data.ks
        this.form.credit.rs = data.rs
      },
      type_change: function () {
        var selected = this.select.type.filter(a => a.value == this.form.type)[0]
        if (selected) this.form.direction = selected.direction
      },
      contract_filter: function (item, query, text) {
        if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.date_formatted.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.date_number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (query.indexOf('/') > -1) {
          if (item.number.toUpperCase().indexOf(query.toUpperCase().substring(0, 3)) > -1 &&
            item.date_number.toUpperCase().indexOf(query.toUpperCase().substring(4)) > -1
          ) return true
        }
        return false
      },
      operation_filter: function (item, query, text) {
        if (item.description.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.recipient && item.recipient.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.payer && item.payer.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (String(item.sum).indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      create_transaction: function () {
        this.$emit('create', JSON.parse(JSON.stringify(this.form)))
        this.form = {
          contract: '',
          date: {
            create: '',
          },
          type: 0,
          direction: 1,
          description: '',
          debet: {
            bic: '',
            bank_name: '',
            ks: '',
            rs: '',
          },
          credit: {
            bic: '',
            bank_name: '',
            ks: '',
            rs: '',
          },
          sum: 0,
          state: 1,
          payments: [],
        }
      },
      save_transaction: function () {
        if (this.form.id) {
          this.axios.post('/api/transaction/save', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$emit('close')
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else { this.$emit('change', this.form) }
      },
    },
  }
</script>
